import { IDriverLocation } from "models/dispatch";
import { IPlace } from "models/place";

interface IProps {
  place: IPlace;
}

export default function PlaceInfo({ place }: IProps) {
  return (
    <div className="w-full">
      <h1 className="mt-1 text-black font-semibold text-base">{place.name}</h1>
    </div>
  );
}
